import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { filterBoolean } from '@core/common-legacy';
import { createEffectFactory } from '@core/ngrx-legacy';

import { DevFlagsHttpService } from './dev-flags-http.service';
import { DevFlagActions } from './dev-flags.store';

@Injectable({ providedIn: 'root' })
export class DevFlagsEffects {
  private readonly actions$ = inject(Actions);
  private readonly devFlagsHttpService = inject(DevFlagsHttpService);

  public effects = createEffectFactory(DevFlagActions, this.actions$);

  public loadDevFlags$ = this.effects(DevFlagActions.fetch, () =>
    this.devFlagsHttpService.fetch().pipe(filterBoolean),
  );
}
